import { render } from "./PeppolDocumentDetail.vue?vue&type=template&id=30e4ae05&scoped=true"
import script from "./PeppolDocumentDetail.vue?vue&type=script&lang=js"
export * from "./PeppolDocumentDetail.vue?vue&type=script&lang=js"

import "./PeppolDocumentDetail.vue?vue&type=style&index=0&id=30e4ae05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e4ae05"]])

export default __exports__